import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { DatabaseProvider } from '../database/database';
import { Collection } from 'lokijs';
import { MailProvider } from '../mail/mail';
import { AlertController } from 'ionic-angular';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';
import moment from 'moment';

/*
  Generated class for the ReserveProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ReserveProvider {
  private reserveCollection: Collection;
  constructor(private api: ApiProvider, private db: DatabaseProvider, private mail: MailProvider, private alerter: AlertController, private toast: ToastAlertsProvider) {
    this.reserveCollection = this.db.getCollection('reserve');
  }

  async getRooms(locationIds, date, roomId?, classId?) {
    let rooms: any = false;
    if (rooms && rooms.length > 0) {
    }

    let now = moment(date);
    if(!date) {
      now = moment();
    }
    // bookingLimitBookings
    // bookingLimitTypeBookings
    // bookingLimitPeriodBookings
    // bookingLimitPeriodUnitBookings
    // bookingLimitHours
    // bookingLimitTypeHours
    // bookingLimitPeriodHours
    // bookingLimitPeriodUnitHours
    const queryRooms = `{
      getRooms(locations: ${locationIds}, getHoursByDate: "${now.format("YYYY-MM-DD")}", ${roomId ? "id:"+roomId+"," : '' } ${classId ? "classId:"+classId+"," : '' }){
        roomHours {
          day, date, start, end, exceptionReason
        },
        id, name, image, title, tcLink, enabled, roomType, localOnly, setupTime, appTcLink, parentRoom, unmediated, description, breakdownTime, locationId, parents, children, layouts {
          id, name, roomId, capacity, setupTime, description, breakdownTime, layoutType {
            name, image
          }
        },
        customQuestions{
          title
          helpText
          link
          required
          validate
          regex
          type
          name
          options
        },
        fixedAssets{
           name, roomId, quantity
        },
        assets{
          id, name, roomId, quantity, staffOnly, locationId, maxPerBooking, minPerBooking
        },
        unmediated bookable viewable segmentSizeInMinutes segmentsPerBlock dayStartBuffer dayEndBuffer roomCharge roomChargePeriod
        bookingLimits {
          minimumBookingInMinutes
          maximumBookingInMinutes
          nearestBookingInDays
          furthestBookingInDays
        },
        sizeAndCapacity{
          area, width, length, capacity
        }
      }
    }`;

    rooms = await this.api.query(queryRooms);
    rooms.getRooms.sort((a,b)=>{
      return a.name.localeCompare(b.name);
    })
    return rooms.getRooms;
  }

  async getAllRooms(date?: string) {
    let rooms: any = false;
    if (rooms && rooms.length > 0) {

    }
    let searchDate = moment();
    if(date) {
        searchDate = moment(date);
    }
    const queryRooms = `{
      getRooms(getHoursByDate: "${moment(searchDate).format('YYYY-MM-DD')}") {
        id, name, image, title, tcLink, enabled, roomType, localOnly, setupTime, appTcLink, parentRoom, unmediated, description, breakdownTime, locationId, parents, children, layouts {
          id, name, roomId, capacity, setupTime, description, breakdownTime, layoutType {
            name, image
          }
        },
        roomHours {
          start,
          end,
          day,
          exceptionReason,
          date
        }
        customQuestions{
          title
          helpText
          link
          required
          validate
          regex
          type
          name
          options
        },
        fixedAssets{
           name, roomId, quantity
        },
        assets{
          id, name, roomId, quantity, staffOnly, locationId, maxPerBooking, minPerBooking
        },
        unmediated bookable viewable segmentSizeInMinutes segmentsPerBlock dayStartBuffer dayEndBuffer roomCharge roomChargePeriod
        bookingLimits {
          minimumBookingInMinutes
          maximumBookingInMinutes
          nearestBookingInDays
          furthestBookingInDays
        },
        sizeAndCapacity{
          area, width, length, capacity
        }
      }
    }`;

    rooms = await this.api.query(queryRooms);
    rooms.getRooms.sort((a,b)=>{
      return a.name.localeCompare(b.name);
    })
    return rooms.getRooms;
  };

  async getReservations(startDate: string, endDate: string, id?: number) {
    let reservations: any = false;
    if (reservations && reservations.length > 0) {

    }

    let queryReservations;
    if (!id) {
      queryReservations = `{
        allReservations(startDate:"${startDate}", endDate:"${endDate}", limit:10000) {
          type,roomId,eventId,endTime,status,roomName,startTime,setupTime,groupName,locationId,bookingType,contactName,displayName,locationName,contactPhone,contactEmail,breakdownTime,eventSeriesId,reservationId,expectedAttendees,firstName,lastName,libraryCard,noShow
        }
      }`;
    }
    else {
      queryReservations = `{
        allReservations(roomId:${id}, startDate:"${startDate}", endDate:"${endDate}") {
          type,roomId,eventId,endTime,status,roomName,startTime,setupTime,groupName,locationId,bookingType,contactName,displayName,locationName,contactPhone,contactEmail,breakdownTime,eventSeriesId,reservationId,expectedAttendees,firstName,lastName,libraryCard,noShow
        }
      }`;
    }

    reservations = await this.api.query(queryReservations);
    reservations.allReservations.sort((a,b)=>{
      return moment(a.startTime).diff(b.startTime)
    })
    return reservations.allReservations;
  }

  async createReservation(reserveArray: any, bookingSource: string) {
    // console.log(reserveArray);
    //reserveObj = JSON.stringify(reserveObj);
    let params = {
      input: reserveArray,
      paymentMethod: "OFFLINE",
      bookingSource
    };

    let reserveQuery = `
      mutation booking($input: [roomBookingType], $paymentMethod: PaymentMethods, $bookingSource: BookingSourceEnum!) {
        saveBooking(input: $input, paymentMethod: $paymentMethod, bookingSource: $bookingSource){
          success
          total
          bookingResponses{
            ok
            message
            data {
              contact_first_name
              contact_last_name
              contact_email
              contact_phone
              room
              location
              display_name
              group_name
              date
              start_time
              end_time
              reference
              library_name
              remotelock_has_code
              remotelock_lock_code
            }
          }
        }
      }
    `;

    let response = await this.api.query(reserveQuery, params);
    if (response) {
      if (response.saveBooking) {
        // Then we have something back from the server
        // Response object is like this: { message: '', ok: t/f, data: {} }
        /* .data ONLY exists on success.
          this.return.data = {
            contact_first_name,
            contact_last_name,
            contact_email,
            contact_phone,
            room,
            location,
            display_name,
            group_name,
            date,
            start_time,
            end_time,
            reference,
            library_name,
          } ;

          These items are named SPECIFICALLY to fields in the database.
        */
        // response.saveBooking.bookingResponses.forEach(booking => {
          // if (booking.ok) {
          //   // let notificationDetails = {
          //   //   type: 'room_reservation_conformation',
          //   //   fields: booking.data
          //   // };
          //   let params = {
          //     template: 'room_reservation_request',
          //     email: booking.data.contact_email,
          //     phone: booking.data.contact_phone
          //   }
          //   // console.log(params, booking.data);
          //   // console.log(notificationDetails);
          //   // this.mail.sendPresetNotification(notificationDetails);
          //   this.mail.sendReserveConfirmationEmail(params, booking.data);
          // }
        // });
      }
    }

    return response.saveBooking;
  }

  async signInForReservation(patronBarcode: string, patronPin: string, roomId: number) {
    let params = {
      input: {
          patronBarcode: patronBarcode,
          patronPin: patronPin,
          roomId: roomId
      }
    };
    let query = `
    mutation booking($input: roomBookingSignInInputType) {
      signIn(input: $input) {
        success
        message
        i18ncode
      }
    }`;
    return await this.api.query(query, params);
  }

  async patronEndReservation(patronBarcode: string, patronPin: string, roomId: number) {
    let params = {
      input: {
        patronBarcode: patronBarcode,
        patronPin: patronPin,
        roomId: roomId
      }
    };
    let query = `
    mutation booking($input: roomBookingSignInInputType){
      signOut(input: $input) {
        success
        message
        i18ncode
      }
    }`;
    return await this.api.query(query, params);
  }

  async staffEndReservation(staffPin: number, roomId: number) {
    let params = {
      input: {
        staffPin: staffPin,
        roomId: roomId
      }
    };
    let query = `
    mutation booking($input: roomBookingSignInInputType) {
      signOut(input: $input) {
        success
        message
        i18ncode
      }
    }`;
    return await this.api.query(query, params);
  }

  async getAvailableAssets(roomId: number, startDate: string, endDate: string) {
    let assets: any = false;

    let query = `{
      getAvailableAssets(roomId:${roomId} startDate:"${startDate}" endDate:"${endDate}") {
       id name quantity bookingMax bookingMin staffOnly cost
      }
    }`;

    assets = await this.api.query(query);
    // console.log(assets);
    assets.getAvailableAssets.sort((a,b)=>{
      return (a.name < b.name)? -1 : (a.name > b.name)? 1 : 0;
    })
    return assets.getAvailableAssets;
  }

  showAlert(title, message) {
    let alert = this.alerter.create({
      title: title,
      subTitle: message,
      buttons: ['OK']
    });

    alert.present();
  }

  triggerToast(msg, messageTitle) {
    this.toast.triggerToast(msg, messageTitle);
  }
}



// WEBPACK FOOTER //
// ./src/providers/reserve/reserve.ts